// Population growth and the auto-collection unlock. Population climbs toward the
// housing cap; once it reaches the threshold the settlement starts gathering on
// its own (the blueprint's "assign workforce, gathering continues automatically"
// moment), which is a deliberate early milestone.

import type { GameState } from '@core/state';
import { BALANCE } from '@data/balance';
import { bus } from '@core/events';
import { t } from '@i18n/i18n';
import { populationCap } from './stats';

export function updatePopulation(state: GameState, dt: number): void {
  const cap = populationCap(state);
  if (state.run.population < cap) {
    state.run.population = Math.min(
      cap,
      state.run.population + BALANCE.population.growthPerSec * state.run.modifiers.popGrowthMult * dt,
    );
  }

  if (!state.run.autoUnlocked) {
    const gatherers =
      state.run.buildings.lumberCamp + state.run.buildings.quarry + state.run.buildings.mine;
    if (
      state.run.population >= BALANCE.autoCollect.unlockPopulation &&
      gatherers >= BALANCE.autoCollect.unlockGatherers
    ) {
      state.run.autoUnlocked = true;
      bus.emit('milestone', {
        title: t('milestone.autoTitle'),
        subtitle: t('milestone.autoSub'),
        tone: 'good',
      });
    }
  }
}
